export default __webpack_public_path__ + "static/payrollServices-c130d055991c129f943bf54ae9262ad3.jpg";